import { menues } from '@/const/menues'

export default {
  namespaced:true,
  state : {  
    items:menues,
  },
  mutations : { 
    MUTATION_ITEMS (state,data) { 
      state.items = data 
    }
  },
  getters : { 
    GETTERS_ITEMS :state=>state.items, 
  },
} 